module.exports = __webpack_public_path__ + "static/the-female-persuasion-66d278cacbdf98cfe30af184f73d96fa.jpg";